"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MenuItem = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));
var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));
var _ArrowRight = _interopRequireDefault(require("@material-ui/icons/ArrowRight"));
var _Radio = require("../radio/Radio");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-bitwise */

const useStyles = (0, _styles.makeStyles)(theme => ({
  menuItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  disabled: {
    backgroundColor: theme.palette.action.disabled
  },
  avatar: {
    height: 24,
    marginRight: 16,
    width: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  specialMenuItem: {
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  formLabel: {
    '&:hover': {
      backgroundColor: '#fff'
    }
  },
  specialDisabled: {
    backgroundColor: 'none'
  },
  checkbox: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(98, 76, 146, .08)'
    }
  },
  cascadeLabel: {
    flex: 1
  }
}));
const MenuItem = _ref => {
  let {
    disabled,
    icon,
    checked,
    onChange,
    radio,
    checkbox,
    children,
    value,
    label,
    valueName,
    onClick,
    cascade,
    className
  } = _ref;
  const classes = useStyles();
  const [isOverButton, setIsOverButton] = (0, _react.useState)(false);
  const [isOverMenu, setIsOverMenu] = (0, _react.useState)(false);
  const anchorEl = (0, _react.useRef)();
  if (cascade) {
    const isOpen = isOverButton || isOverMenu;
    const maxHeight = window.innerHeight - ~~anchorEl?.current?.getBoundingClientRect?.()?.top - 10;
    const minHeight = 200;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: anchorEl,
      onMouseEnter: () => setIsOverButton(true),
      onMouseLeave: () => setIsOverButton(false),
      onClick: onClick,
      role: "button",
      tabIndex: 0,
      onKeyDown: onClick
    }, /*#__PURE__*/_react.default.createElement(MenuItem, {
      value: value,
      icon: icon
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.cascadeLabel
    }, label), /*#__PURE__*/_react.default.createElement(_ArrowRight.default, null))), /*#__PURE__*/_react.default.createElement(_core.Popper, {
      placement: maxHeight < minHeight ? 'right-end' : 'right-start',
      open: isOpen,
      anchorEl: anchorEl.current,
      onMouseEnter: () => setIsOverMenu(true),
      onMouseLeave: () => setIsOverMenu(false),
      onClick: () => setIsOverMenu(false),
      className: className
    }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
      style: {
        maxHeight: Math.max(maxHeight, minHeight),
        overflow: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_core.MenuList, null, children))));
  }
  if (radio) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    radio: radio,
    className: disabled ? classes.specialDisabled : classes.specialMenuItem,
    disabled: disabled,
    value: value,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    className: classes.formLabel,
    value: value,
    control: /*#__PURE__*/_react.default.createElement(_Radio.Radio, null),
    label: label
  }));
  if (checkbox) return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    checkbox: checkbox,
    className: disabled ? classes.specialDisabled : classes.specialMenuItem,
    disabled: disabled,
    value: value,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
      className: classes.checkbox,
      checked: checked,
      onChange: onChange,
      name: valueName,
      icon: /*#__PURE__*/_react.default.createElement(_CheckBoxOutlineBlank.default, {
        className: disabled ? null : classes.checkbox
      }),
      checkedIcon: /*#__PURE__*/_react.default.createElement(_CheckBox.default, {
        className: disabled ? classes.checkboxDisabled : classes.checkbox
      })
    }),
    label: label
  }));
  return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
    className: disabled ? classes.disabled : classes.menuItem,
    disabled: disabled,
    value: value,
    onClick: onClick
  }, icon && /*#__PURE__*/_react.default.createElement(_core.Badge, {
    className: classes.avatar
  }, icon), children);
};
exports.MenuItem = MenuItem;
MenuItem.propTypes = {
  /**
   * Conteúdo do menuItem
   */
  children: _propTypes.default.node.isRequired,
  /**
   * Se TRUE, o componente fica desabilitado
   */
  disabled: _propTypes.default.bool,
  /**
   * Valor do conteudo (para casos de uso em select)
   */
  value: _propTypes.default.string,
  /**
   * Ícone caso o tenha
   */
  icon: _propTypes.default.node,
  /**
   * Se TRUE o componente é do estilo radio
   */
  radio: _propTypes.default.bool,
  /**
   * Se TRUE o componente é do estilo checkbox
   */
  checkbox: _propTypes.default.bool,
  /**
   * Texto do radio button ou checkbox
   */
  label: _propTypes.default.string,
  /**
   * Nome do checkbox para manipulacao de estado
   */
  valueName: _propTypes.default.string,
  /**
   * Se TRUE, o checkbox é marcado. Serve para manipulacao de estado
   */
  checked: _propTypes.default.bool,
  /**
   * funcao para alterar estados dos componentes
   */
  onChange: _propTypes.default.func,
  /**
   * funcao executada ao selecionar um componente
   */
  onClick: _propTypes.default.func,
  /**
   * Se TRUE o componente é do estilo cascading
   */
  cascade: _propTypes.default.bool,
  /**
   * Adição de classe no componente principal
   */
  className: _propTypes.default.string
};
MenuItem.defaultProps = {
  disabled: false,
  value: '',
  icon: null,
  label: 'check?',
  radio: false,
  checkbox: false,
  valueName: '',
  checked: false,
  onChange: null,
  onClick: null,
  cascade: false,
  className: null
};
var _default = exports.default = MenuItem;